import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/UserModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { DatePicker, MySelect, Text, TextArea, TextEmail, TextNumber, TextPassword, MyReactSelectMultiple } from '../../inputs/inputs';
import { getDesignations } from '../../../models/MasterModel';
import { getData as getClients } from '../../../models/ClientsModel';
import { getData as getContacts } from '../../../models/ContactsModel';
import { formatDataBeforeDisplay, formatDataBeforeSend, isSuperAdminUser, validorSettings } from '../../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';

let cacheManagers = [];

export const UserForm = ({module, showModal, setShowModal, refreshData, data, modalKey = null}) => {

  const [userClients, setUserClients] = useState('');
  const [userContacts, setUserContacts] = useState('');
  const [isClientSpecific, setIsClientSpecific] = useState(0);
  const inputFields = {
    user_first_name: '',
    user_last_name: '',
    user_gender: '',
    user_dob: '',
    user_designation_id: '',
    user_manager_id: '',
    user_role_id: '',
    user_mobile: '',
    user_email: '',
    user_password: '',
    user_start_date: '',
    user_address: '',
    user_client_id: userClients,
    user_contact_id: userContacts,
    user_client_specific: isClientSpecific,
  }
  const formatOptions = [
    {
      type: 'react-datepicker',
      column: 'user_dob'
    },
    {
      type: 'react-datepicker',
      column: 'user_start_date',
    },
    // {
    //   type: 'react-select-multiple',
    //   column: 'user_client_id',
    // },
    // {
    //   type: 'react-select-multiple',
    //   column: 'user_contact_id',
    // },
  ];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const optionsGender = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'other', label: 'Other' },
  ];

  const [userRoles, setUserRoles] = useState([]);
  const [managers, setManagers] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [clients, setClients] = useState([]);
  const [contacts, setContacts] = useState([]);
  

  useEffect(() => {
    const fetchUserRoles = async() => {
      try {
        let apiParam = {user_token: user_data.user_token};
        const response = await model.getUserRoles(apiParam);

        if (typeof response != typeof undefined) {
          const options = response.user_roles.map(ele => ({
            value: ele._urole_id,
            label: ele.urole_title,
            isClientSpecific: ele.role_client_specific
          }));
          setUserRoles(options);

          setNotificationCount(localStorage.getItem('unread_notification_count'));
        }
      } catch (error) {
          console.error(error);
      }
    }

    const fetchManagers = async() => {
      try {
        let apiParam = {user_token: user_data.user_token};
        //const response = await model.getManagersExceptMe(apiParam);
        const response = await model.getManagers(apiParam);

        if (typeof response != typeof undefined) {
          cacheManagers = response.managers;
          const options = response.managers.map(ele => ({
            value: ele._user_id,
            label: ele.user_first_name + ' ' + ele.user_last_name
          }));

          setManagers(options);
        }
      } catch (error) {
          console.error(error);
      }
    }

    const fetchDesignations = async() => {
      try {
        let apiParam = {user_token: user_data.user_token};
        const response = await getDesignations(apiParam);

        if (typeof response != typeof undefined) {
          const options = response.designations_master.map(ele => ({
            value: ele._designation_id,
            label: ele.designation_name
          }));

          setDesignations(options);
        }
      } catch (error) {
        console.error(error);
      }
    }
    const fetchClients = async () => {
      try {
        const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1});
        if (! result) return;

        const clientOptions = result.clients.map(client => ({
          value: client._client_id,
          label: client.client_name
        }));
        // Add "All" option
        const allOption = { value: -1, label: "All" };
        setClients([allOption, ...clientOptions]);
        //setClients(clientOptions);
      } catch (error) {
        console.error(error);
      }
    };

    fetchUserRoles();
    fetchManagers();
    fetchDesignations();
    fetchClients();
    //fetchContacts();
  }, []);

  const checkRoleType = (event) => {
    const selectedOption = userRoles.find(
      (option) => option.value === event
    ); // Find the matching object
    const isSpecific = selectedOption ? selectedOption.isClientSpecific : 0;
    setIsClientSpecific(isSpecific);
    //console.log('isSpecific =>',isSpecific);
    //console.log('isClientSpecific => ',isClientSpecific);
  };
  const fetchContacts = async() => {
    if (!fields.user_client_id || fields.user_client_id.length === 0) {
      fields.user_client_id = '';
      setContacts([]);
      return;
    }
    // Map to extract `value` fields and join them with commas
    const userClientIds = Array.isArray(fields.user_client_id) ? fields.user_client_id.map((item) => item.value).join(',') : '';
    console.log('userClientIds =>',userClientIds);
    setUserClients(userClientIds);
    try{
      let apiParam = {user_token: user_data.user_token, 'contact_client_id': userClientIds, page: 1, limit: -1};
      const response = await getContacts(apiParam);

      if (typeof response != typeof undefined) {

        let options = [];
        let flag = false;
        response.client_contacts.forEach(function(item) {
          // if (fields.user_contact_id == item._contact_id || fields.user_contact_id?.value == item._contact_id) {
          //   flag = true;
          // }
          options.push({
            value: item._contact_id,
            label: item.contact_name
          });
        });

        // if (! flag) {
        //   fields.user_contact_id = '';
        // }
        // Add 'All' option
        options.unshift({ value: -1, label: 'All' });
        setContacts(options);
      }
    }catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    //console.log('client change => ', fields.user_client_id);
    const selected = fields.user_client_id;

    if (!selected) return;

    // If 'All' is selected, keep only that
    if (Array.isArray(selected)) {
      const hasAll = selected.some((opt) => opt.value === -1);
      if (hasAll && selected.length > 1) {
        const onlyAll = selected.filter((opt) => opt.value === -1);
        setFields((prev) => ({ ...prev, user_client_id: onlyAll }));
      }
    }
    
    fetchContacts();
  },[fields.user_client_id]);
  useEffect(() => {
    const getContacts = async() => {
      const userContactIds = Array.isArray(fields.user_contact_id)
      ? fields.user_contact_id.map((item) => item.value).join(',') : '';
      console.log('userContactIds =>',userContactIds);
      setUserContacts(userContactIds);
    };
    getContacts();

    const selected = fields.user_contact_id;

    if (!selected) return;

    if (Array.isArray(selected)) {
      const hasAll = selected.some((opt) => opt.value === -1);
      if (hasAll && selected.length > 1) {
        const onlyAll = selected.filter((opt) => opt.value === -1);
        setFields((prev) => ({ ...prev, user_contact_id: onlyAll }));
      }
    }

  }, [fields.user_contact_id]);

  const closeModal = () =>{
    setId('');
    setFields(inputFields);
    setErrors({});

    setShowModal(false);
  }

  useEffect(() => {
    let options = [];
    for (let item of cacheManagers) {
      if (id == item._user_id) {
        continue;
      }

      options.push({
        value: item._user_id,
        label: item.user_first_name + ' ' + item.user_last_name
      });
    }
    setManagers(options);
  }, [id]);

  useEffect(() => {
    // This effect will be called whenever data changes
    if (data) {
      setId(data[module.primaryCol]);
      console.log("contacts", contacts);
      setIsClientSpecific(data.role_client_specific);
      setUserClients(data.user_clients);
      setUserContacts(data.user_contacts);
      //fetchContacts();
      const temp = formatDataBeforeDisplay(data, formatOptions);
      //const user_ids = temp?.user_clients?.split(",");
      const contact_ids = temp?.user_contacts?.split(",");
      //console.log("contact_ids", contact_ids);
      //console.log("contacts ", contacts);
      //const matches = clients.filter((client) => user_ids?.includes(client.value));
      
      //const matches_contacts = contacts.filter((contact) => contact_ids?.includes(contact.value));
      // console.log("matches_contacts", matches_contacts);
      
      //temp.user_contact_id = matches_contacts;
      
      //fields.user_contact_id = matches_contacts;

      const user_ids = temp?.user_clients?.split(",");
      let matches;
      if (user_ids?.includes("-1") || user_ids?.includes(-1)) {
        matches = [{ value: -1, label: "All" }];
      } else {
        matches = clients.filter((client) => user_ids?.includes(client.value));
      }
      temp.user_client_id = matches;

      let matches_contacts;
      if (contact_ids?.includes("-1") || contact_ids?.includes(-1)) {
        matches_contacts = [{ value: -1, label: "All" }];
      } else {
        matches_contacts = contacts.filter((contact) =>
          contact_ids?.includes(contact.value)
        );
      }
      temp.user_contact_id = matches_contacts;
      if (temp.user_is_active === undefined || temp.user_is_active === null) {
        temp.user_is_active = 1;
      }
      setFields(temp);
      fields.user_client_id = matches;
      fields.user_contact_id = matches_contacts;
      setErrors({});
    }
  }, [data, modalKey]);

  const validator = useRef(new SimpleReactValidator(validorSettings()));
  const submit = async(e) => {
    e.preventDefault();

    if (! validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
      if (data) {
        let active =
          fields.user_is_active == 1 ||
          fields.user_is_active === true ||
          fields.user_is_active === "1";
        if (isSuperAdminUser(data)) {
          active =
            data.user_is_active == 1 ||
            data.user_is_active === true ||
            data.user_is_active === "1" ||
            String(data.user_is_active || "").toLowerCase() === "active";
        }
        formData.set("user_is_active", active ? 1 : 0);
      }

      let response;
      if (data) {
        response = await model.update(user_data.user_token, data.user_unique_id, formData);
      } else {
        response = await model.create(user_data.user_token, formData);
      }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        closeModal();

        model.saveToStorage(response.data[module.key], response.data.pagination);
        refreshData();
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    setLoading(false);
  }

  return (
    <Modal className="cms-modal-form" show={showModal} onHide={closeModal} size='xl' backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{modalKey == null ? 'Add' : 'Edit'} {module.singularTitle}</Modal.Title>
      </Modal.Header>

      <form onSubmit={submit}>
        <Modal.Body>
          <div className="row gy-2 mb-3">
            <div className="col-xl-4">
              <Text column="user_first_name" label="First Name" required={true} fields={fields} setFields={setFields} errors={errors} />
            </div>
            <div className="col-xl-4">
              <Text column="user_last_name" label="Last Name" required={true} fields={fields} setFields={setFields} errors={errors} />
            </div>
            <div className="col-xl-4">
              <div className="">
                <DatePicker column="user_dob" required={true} label="Date of Birth" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>
          </div>
          <div className="row gy-2">
            <div className="col-xl-4 mb-3">
              <MySelect options={optionsGender} required={true} column="user_gender" label="Gender" fields={fields} setFields={setFields} errors={errors} />
            </div>
            <div className="col-xl-4 mb-3">
              <MySelect options={designations} column="user_designation_id" label="Designation" fields={fields} setFields={setFields} errors={errors} />
            </div>
            <div className="col-xl-4 mb-3">
              <MySelect options={managers} column="user_manager_id" label="Manager" fields={fields} setFields={setFields} errors={errors} />
            </div>
            {user_data.user_unique_id != fields.user_unique_id ? 
              <div className="col-xl-4 mb-3">
                <MySelect column="user_role_id" label="User Role" options={userRoles} onChange={checkRoleType} required={true} fields={fields} setFields={setFields} errors={errors} />
              </div>
              : ''
            }
            <div className="col-xl-4 mb-3" style={{display: (isClientSpecific == 1 ? 'block' : 'none')}}>
              <MyReactSelectMultiple options={clients} column="user_client_id" required={true} label="Client" fields={fields} setFields={setFields} errors={errors}  />
            </div>
            <div className="col-xl-4 mb-3" style={{display: (isClientSpecific == 1 ? 'block' : 'none')}}>
              <MyReactSelectMultiple options={contacts} column="user_contact_id" required={true} label="POC" fields={fields} setFields={setFields} errors={errors}  />
            </div>
            <div className="col-xl-4 mb-3">
              <TextNumber column="user_mobile" label="Mobile" required={true} fields={fields} setFields={setFields} errors={errors} validator={validator} rules='min:10|max:10' />
            </div>
            <div className="col-xl-4 mb-3">
              <TextEmail column="user_email" label="Email" setFields={(cb) => setFields((prev) => ({...prev,user_email: typeof cb === "function" ? cb(prev).user_email.toLowerCase() : cb.user_email.toLowerCase()}))} required={true} fields={fields}  errors={errors} validator={validator} rules='email' />
            </div>
            {user_data.user_unique_id != fields.user_unique_id ? 
              <div className="col-xl-4 mb-3">
                <TextPassword isEdit={modalKey != null} column="user_password" label="Password" required={true} fields={fields} setFields={setFields} errors={errors} />
              </div>
              : ''
            }
            <div className="col-xl-4 mb-3">
              <DatePicker column="user_start_date" label="Start Date" fields={fields} setFields={setFields} errors={errors} />
            </div>
            <div className="col-xl-4 mb-3">
              <TextArea column="user_address" label="Address" fields={fields} setFields={setFields} errors={errors} />
            </div>
            {data ? (
              <div className="col-xl-4 mb-3">
                <div className="form-label">Account status</div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="user_is_active_switch"
                    disabled={isSuperAdminUser(data)}
                    checked={
                      fields.user_is_active == 1 ||
                      fields.user_is_active === true ||
                      fields.user_is_active === "1"
                    }
                    onChange={(e) =>
                      setFields((prev) => ({
                        ...prev,
                        user_is_active: e.target.checked ? 1 : 0,
                      }))
                    }
                    title={
                      isSuperAdminUser(data)
                        ? "Super Admin status cannot be changed"
                        : undefined
                    }
                  />
                  <label className="form-check-label" htmlFor="user_is_active_switch">
                    {fields.user_is_active == 1 ||
                    fields.user_is_active === true ||
                    fields.user_is_active === "1" ? (
                      <span className="badge bg-success text-white">Active</span>
                    ) : (
                      <span className="badge bg-secondary text-white">Inactive</span>
                    )}
                  </label>
                  {isSuperAdminUser(data) && (
                    <div className="form-text text-muted small mt-1">
                      Super Admin status cannot be changed.
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
          <button className="btn btn-primary" disabled={loading}>
            {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Submit'}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
